import React, { useCallback, useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { RWebShare } from "react-web-share";
import useRazorpay, { RazorpayOptions } from "react-razorpay";
import {
  IEvent,
  fetchEventById,
} from "../../screens/header/home-page/HomePageController";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  IOrderPremiumPackage,
  submitPremiumPackageBooking,
} from "../../screens/premium-package/PremiumPackagesController";
import { RP_KEY_ID } from "../../config/AppConfig";
import { userRoute } from "../../routes/RouteUser";
import { sweetAlertError, sweetAlertSuccess } from "../../utils/AppFunctions";
import BackButton from "../../components/common/BackButton";
import {
  premiumIcon,
  rupeeIcon,
  shareItemIcon,
  whitePremiumIcon,
  whiteRupeeIcon,
} from "../../assets/icons/SvgIconList";
import PwaCarousel from "../../components/common/PwaCarousel";
import {
  ENTITY_TYPE,
  IS_PAID_EVENT,
  IS_SUBSCRIBED,
  PUBLIC_HEADER_TABS,
} from "../../utils/AppEnumerations";
import ICButton from "../../core-component/ICButton";
import PublicCarousel from "../insights-in-use/PublicCarousel";
import { useFormik } from "formik";
import {
  handleSubmitRegistrationForm,
  initialValuesEventForm,
  registrationFormValidationSchema,
} from "../../components/event-details/EventDetailControler";
import ICTextInput from "../../core-component/ICTextInput";
import EventDetailSkeleton from "../../components/event-details/event-details-skeleton/EventDetailSkeleton";
import ICCustomModal from "../../components/common/ICCustomModal";
import { publicRoute } from "../../routes/RoutePublic";
import { localStorageUtils } from "../../utils/LocalStorageUtil";
import PublicHeader from "../public-header/PublicHeader";
const EventDetail = () => {
  const navigate = useNavigate();
  const [eventsList, setEventList] = useState<IEvent>();
  const [loading, setLoading] = useState(false);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const { t } = UseTranslationHook();
  const location = useLocation();
  const currentUrl = location.pathname;
  const id = location?.state?.id;

  useEffect(() => {
    fetchEventById(setEventList, setLoading, t, id, false);
  }, []);
  const formik = useFormik({
    validationSchema: registrationFormValidationSchema(t),
    initialValues: initialValuesEventForm(id),
    onSubmit: async (values) => {
      formik.setSubmitting(true);

      await handleSubmitRegistrationForm(values, setShowRegistrationModal);
      formik.setSubmitting(false);
    },
  });
  const registerEventForm = (
    <>
      <div className="mt-5">
        <ICTextInput
          name={"first_name"}
          placeholder={t("first_name")}
          value={formik.values.first_name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMessage={
            formik.touched.first_name ? formik.errors.first_name : undefined
          }
          isActive={isActive}
        />
      </div>
      <div className="mt-5">
        <ICTextInput
          name={"last_name"}
          placeholder={t("last_name")}
          value={formik.values.last_name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMessage={
            formik.touched.last_name ? formik.errors.last_name : undefined
          }
          isActive={isActive}
        />
      </div>
      <div className="mt-5">
        <ICTextInput
          name={"participant_age"}
          placeholder={t("participant_age")}
          type="number"
          value={formik.values.participant_age}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMessage={
            formik.touched.participant_age
              ? formik.errors.participant_age
              : undefined
          }
          isActive={isActive}
        />
      </div>
      <div className="mt-5">
        <ICTextInput
          name={"email_address"}
          placeholder={t("email")}
          type="email"
          value={formik.values.email_address}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMessage={
            formik.touched.email_address
              ? formik.errors.email_address
              : undefined
          }
          isActive={isActive}
        />
      </div>
      <div
        className={`text-center ${isActive ? "text-skin-insights" : ""} mt-5`}
      >
        OR
      </div>
      <div className="">
        <ICTextInput
          name={"mobile_number"}
          placeholder={t("mobile_number")}
          type="number"
          value={formik.values.mobile_number}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMessage={
            formik.touched.mobile_number
              ? formik.errors.mobile_number
              : undefined
          }
          isActive={isActive}
        />
      </div>
    </>
  );
  const sessionKey = localStorageUtils.getAccessToken();
  return (
    <div className="bg-skin-home-bg h-full overflow-hidden flex flex-col">
      <div className="h-24">
        <PublicHeader activeTab={PUBLIC_HEADER_TABS.Events} />
      </div>

      {!loading ? (
        <div className="flex-1 flex flex-col items-center overflow-scroll">
          <div className="flex justify-start w-full items-center comman-padding">
            <BackButton containerClassName="!bg-white" />
          </div>
          {eventsList && (
            <div className="xl:w-1/2 w-full">
              <div className="w-full public-event">
                {eventsList && <PublicCarousel items={eventsList.app_media} />}
              </div>
              <div className="event-description !bg-skin-insights-card flex flex-col justify-center w-full comman-padding top">
                <div>
                  <div className="flex items-center text-2xl text-skin-title-insights justify-between">
                    <div className="flex w-full mr-5">
                      <div>
                        {eventsList.is_paid_event === IS_PAID_EVENT.isTrue && (
                          <div className="h-6 w-6">{whitePremiumIcon}</div>
                        )}
                        {eventsList?.title}
                      </div>
                    </div>
                    <div className="flex text-skin-title-insights justify-end">
                      {eventsList.is_paid_event === IS_PAID_EVENT.isTrue && (
                        <>
                          <div className="h-5 w-5 m-1">{whiteRupeeIcon}</div>
                          <div>{eventsList.registration_fee}</div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="top text-lg text-skin-title-insights flex flex-col relative justify-between">
                  <div className="flex justify-between mb-3">
                    <div className="flex items-center">{t("description")}</div>
                    <div className="flex justify-end">
                      {eventsList.is_paid_event === IS_PAID_EVENT.isTrue
                        ? eventsList.has_subscribed === IS_SUBSCRIBED.No && (
                            <ICButton
                              type="button"
                              children={t("subscribe")}
                              loading={loading}
                              onClick={() =>
                                sessionKey
                                  ? navigate(userRoute.eventDetail, {
                                      state: { id: eventsList.id },
                                    })
                                  : navigate(publicRoute.welcome)
                              }
                              className="!bg-skin-home-bg hover:!bg-skin-insights-card !w-fit !text-sm mb-2"
                            />
                          )
                        : eventsList.registration_required ===
                            IS_SUBSCRIBED.Yes && (
                            <ICButton
                              type="button"
                              onClick={() => setShowRegistrationModal(true)}
                              className="!bg-skin-home-bg hover:!bg-skin-insights-card !w-fit !text-sm mb-2"
                            >
                              {t("register")}
                            </ICButton>
                          )}
                    </div>
                  </div>
                  <div className="text-base text-skin-title-insights text-justify">
                    <p>{eventsList?.description}</p>
                  </div>
                  <div className="top text-base text-skin-title-insights">
                    {eventsList.event_start_date && (
                      <p>
                        {t("event_start_date")} :{" "}
                        {eventsList.event_start_date.slice(0, 10)}
                      </p>
                    )}

                    {eventsList.event_end_date && (
                      <p>
                        {t("event_end_date")} :{" "}
                        {eventsList.event_end_date.slice(0, 10)}
                      </p>
                    )}

                    {eventsList.event_start_time &&
                      eventsList.event_end_time && (
                        <p>
                          {t("time")} :{" "}
                          {eventsList.event_start_time.slice(0, 5)} -{" "}
                          {eventsList.event_end_time.slice(0, 5)}
                        </p>
                      )}

                    {!eventsList.event_start_time &&
                      !eventsList.event_end_time && (
                        <p>
                          {t("event_start_date")} :{" "}
                          {eventsList.event_start_date.slice(0, 10)} -{" "}
                          {eventsList.event_end_date.slice(0, 10)}
                        </p>
                      )}
                  </div>
                  <div className="top text-base text-skin-title-insights">
                    <div>
                      {t("venue")} : {eventsList.venue}
                    </div>
                  </div>
                  <div className="top">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3670.1269432859854!2d72.52550517588293!3d23.092448413715868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e832e0c2a0f35%3A0x46133474cb712760!2sDP%20Infosoft!5e0!3m2!1sen!2sin!4v1710850833096!5m2!1sen!2sin"
                      className="w-full"
                      height="450"
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          )}
          {registerEventForm && (
            <ICCustomModal
              title={t("registration_form")}
              content={registerEventForm}
              buttonTitle={t("submit")}
              isModalShow={showRegistrationModal}
              setIsModalShow={setShowRegistrationModal}
              handleSubmitButton={() => {
                formik.handleSubmit();
              }}
              isActive={isActive}
            />
          )}
        </div>
      ) : (
        <EventDetailSkeleton />
      )}
    </div>
  );
};

export default EventDetail;
